import { getLocalStorage, GetLocalStorageConfig, setLocalStorage } from '@app/utilities';
import { useState } from 'react';

/**
 * Get/set a JSON value to/from localStorage.
 *
 * @note If no value is found @see fallback can return a default value.
 */
export function useLocalStorage<T>(
  key: string,
  fallback: () => T,
  config?: GetLocalStorageConfig
): [T, (newValue: T) => void];
export function useLocalStorage<T>(
  key: string
): [T | null, (newValue: T | null) => void];
export function useLocalStorage<T>(
  key: string,
  fallback?: () => T,
  config?: GetLocalStorageConfig
): [T | null, (newValue: T | null) => void] {
  const [value, setStateValue] = useState<T | null>(() => {
    return getLocalStorage(key, fallback, config);
  });

  const setValue = (newValue: T | null): void => {
    setLocalStorage(key, newValue);
    setStateValue(getLocalStorage(key, fallback));
  };

  return [value, setValue];
}
